    /**
 * @module PressOverview
 */
class PressOverview {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._columns = Array.prototype.slice.call(element.querySelectorAll(options.columnSelector));
        this._items = Array.prototype.slice.call(element.querySelectorAll(options.itemSelector));
        this._columnCount = 1;

        this.load();
    }


    /**
     * Base options
     */
    static get options() {
        return {
            columnSelector: '.layout-column',
            itemSelector: '.teaser'
        };
    }


    /**
     * Construct module
     */
    load() {
        window.addEventListener('resize', this._onResize.bind(this));
        this._updateOverview();
    }


    /**
     * Window resize event handler
     * @private
     */
    _onResize() {
        this._updateOverview();
    }


    /**
     * Update the overview if the amount of columns changes
     * @private
     */
    _updateOverview() {
        if (this._updateColumnCount()) {
            this._addColumns();
            this._distributeItems();
            this._removeColumns();
        }
    }


    /**
     * Distribute the items over the available columns
     * @private
     */
    _distributeItems() {
        let i = 0;

        this._items.forEach(item => {
            this._columns[i].appendChild(item);

            i++;

            if (i === this._columnCount) {
                i = 0;
            }
        });
    }


    /**
     * Add missing columns to the DOM
     * @private
     */
    _addColumns() {
        while (this._columns.length < this._columnCount) {
            const column = this._columns[0].cloneNode(false);
            this._element.appendChild(column);
            this._columns.push(column);
        }
    }


    /**
     * Remove unwanted columns from the DOM
     * @private
     */
    _removeColumns() {
        while (this._columns.length > this._columnCount) {
            const column = this._columns.pop();
            column.parentNode.removeChild(column);
        }
    }

    /**
     * Update the column count
     * @return {boolean} - True if columnCount has changed
     * @private
     */
    _updateColumnCount() {
        const columns = Math.round(this._element.offsetWidth / this._columns[0].offsetWidth);

        if (columns !== this._columnCount) {
            this._columnCount = columns;

            return true;
        }

        return false;
    }
}

// Exports
export default PressOverview;
